module.exports = __webpack_public_path__ + "resources/img/sp_radio_v2.d82b20f93b817e9d1a189e24da80fd9a.png";